import React, { useEffect, useState } from "react";
import Layout from "../../components/Admin/AdminLayout";
import AdminHeader from "./component/AdminHeader";
import axios from "axios";
import { message } from "antd";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";

// ✅ Font setup (same as TravelTheme)
const Font = Quill.import("formats/font");
Font.whitelist = [
  "sans-serif",
  "serif",
  "monospace",
  "poppins",
  "montserrat",
  "times-new-roman",
  "georgia",
];
Quill.register(Font, true);

// ✅ Add font styles dynamically
const customFontStyles = `
  .ql-editor .ql-font-poppins { font-family: 'Poppins', sans-serif; }
  .ql-editor .ql-font-montserrat { font-family: 'Montserrat', sans-serif; }
  .ql-editor .ql-font-times-new-roman { font-family: 'Times New Roman', serif; }
  .ql-editor .ql-font-georgia { font-family: 'Georgia', serif; }
`;
const styleTag = document.createElement("style");
styleTag.innerHTML = customFontStyles;
document.head.appendChild(styleTag);

// ✅ Toolbar setup
const modules = {
  toolbar: [
    [{ font: Font.whitelist }, { size: [] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    [{ header: "1" }, { header: "2" }, "blockquote", "code-block"],
    [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
    [{ align: [] }],
    ["link", "image", "video"],
    ["clean"],
  ],
};

const formats = [
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "script",
  "header",
  "blockquote",
  "code-block",
  "list",
  "bullet",
  "indent",
  "align",
  "link",
  "image",
  "video",
];


const AddCategory = () => {
  const [loading, setLoading] = useState(false);
  const [category, setCategory] = useState("");
  const [categoryUrl, setCategoryUrl] = useState(null);
  const [bannerUrls, setBannerUrls] = useState([]);
  const [overview, setOverview] = useState(""); // ✨ new state
  const [allCategory, setAllCategory] = useState(null);

  // Edit mode
  const [editId, setEditId] = useState(null);

  // Upload single thumbnail
  const handleThumbnailUpload = (file) => {
  setCategoryUrl(file);
};

const handleBannerUpload = (files) => {
  setBannerUrls([...bannerUrls, ...files]);
};
  // Remove banner from list
  const removeBanner = (index) => {
    setBannerUrls(bannerUrls.filter((_, i) => i !== index));
  };

  // Get all categories
  const getAllCategory = async () => {
    try {
      const res = await axios.get(`api/category/get-all-category`);
      let arr = res.data.data;
      setAllCategory(arr.reverse());
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (allCategory === null) {
      getAllCategory();
    }
    // eslint-disable-next-line
  }, []);

  // Submit form
  const submit = (e) => {
    e.preventDefault();
    if (!categoryUrl) return message.error("Thumbnail is required");
    if (bannerUrls.length === 0) return message.error("At least one banner required");

    setLoading(true);

    const formData = new FormData();
    formData.append("name", category);
    formData.append("overview", overview);

    // Append thumbnail
    formData.append("url", categoryUrl);

    // Append multiple banner images
    bannerUrls.forEach((file) => {
      formData.append("bannerImages", file);
    });

    const method = editId ? "PUT" : "POST";
    const url = editId
      ? `api/category/update-category/${editId}`
      : `api/category/add-category`;

    axios({
      method,
      data: formData,
      url,
      withCredentials: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((res) => {
        getAllCategory();
        resetForm();
        setTimeout(() => setLoading(false), 1000);
        message.success(res.data.message);
      })
      .catch((err) => {
        setTimeout(() => setLoading(false), 1000);
        console.log(err);
      });
  };


  // Delete category
  const deleteCategory = (id) => {
    axios({
      method: "POST",
      data: { id },
      withCredentials: true,
      url: `api/category/delete-category`,
    })
      .then((res) => {
        getAllCategory();
        setTimeout(() => setLoading(false), 1000);
        message.success(res.data.message);
      })
      .catch((err) => {
        setTimeout(() => setLoading(false), 1000);
        console.log(err);
      });
  };

  // Load data for edit
  const editCategory = (cat) => {
    setEditId(cat._id);
    setCategory(cat.name);
    setCategoryUrl(cat.url);
    setBannerUrls(cat.bannerImages || []);
    setOverview(cat.overview || ""); // ✨ load overview
  };

  // Reset form
  const resetForm = () => {
    setEditId(null);
    setCategory("");
    setCategoryUrl(null);
    setBannerUrls([]);
    setOverview(""); // ✨ reset
  };
// ✅ Add OverviewText component here
const OverviewText = ({ text }) => {
  const [expanded, setExpanded] = useState(false);
  const toggleExpand = () => setExpanded(!expanded);
  return (
    <div>
      <div
        style={{
          display: "-webkit-box",
          WebkitLineClamp: expanded ? "unset" : 4,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        dangerouslySetInnerHTML={{ __html: text }}
      ></div>
      {text.length > 150 && (
        <button
          onClick={toggleExpand}
          style={{
            border: "none",
            background: "none",
            color: "#007bff",
            cursor: "pointer",
            padding: 0,
            marginTop: "5px",
          }}
        >
          {expanded ? "Read Less" : "Read More"}
        </button>
      )}
    </div>
  );
};
  return (
    <Layout>
      <AdminHeader
        title="Add Category"
        redirect="/admin-dashboard"
        btnName="Add Trip"
        btnUrl="/add-trip"
        btnName2="Add Home Category"
        btnUrl2="/add-home-category"
      />
      <div className="Mon_font px-3 m-0 pb-4">
        <form
          className="row g-3 rounded border border-2 m-0 px-2 py-3"
          style={{ backgroundColor: "#f5f5f5" }}
          onSubmit={submit}
        >
          {/* Preview thumbnail */}
          {categoryUrl && (
  <div className="m-0">
    <img
      className="border rounded bg-white m-0 p-1 mb-2"
      width={100}
      src={
        typeof categoryUrl === "string"
          ? categoryUrl
          : URL.createObjectURL(categoryUrl)
      }
      alt="Thumbnail"
    />
  </div>
)}

          {/* Preview banners */}
       {bannerUrls.length > 0 && (
  <div className="m-0 d-flex flex-wrap gap-2">
    {bannerUrls.map((file, i) => (
      <div key={i} className="position-relative">
        <img
          className="border rounded bg-white p-1 mb-2"
          width={100}
          src={
            typeof file === "string"
              ? file
              : URL.createObjectURL(file)
          }
          alt="Banner"
        />
        <button
          type="button"
          className="btn btn-sm btn-danger position-absolute top-0 end-0"
          onClick={() => removeBanner(i)}
        >
          ×
        </button>
      </div>
    ))}
  </div>
)}


          <div className="col-6 m-0">
            <label>Category Name</label>
            <input
              className="form-control"
              type="text"
              required
              value={category}
              placeholder="Enter name"
              onChange={(e) => setCategory(e.target.value)}
            />
          </div>

          <div className="col-3 m-0">
            <label>Thumbnail</label>
            <input
              type="file"
              accept="image/*"
              className="form-control"
onChange={(event) => handleThumbnailUpload(event.target.files[0])}
            />
          </div>

          <div className="col-3 m-0">
            <label>Banner Images (Multiple)</label>
            <input
              multiple
              type="file"
              accept="image/*"
              className="form-control"
onChange={(event) => handleBannerUpload([...event.target.files])}
            />
          </div>

          {/* ✨ Overview input */}
          {/* <div className="col-12 m-0">
            <label>Overview</label>
            <textarea
              className="form-control"
              rows="4"
              placeholder="Write category overview..."
              value={overview}
              onChange={(e) => setOverview(e.target.value)}
            ></textarea>
          </div> */}
          <div className="col-12 m-0">
  <label>Overview</label>
  <ReactQuill
    theme="snow"
    value={overview}
    onChange={setOverview}
    modules={modules}
    formats={formats}
    placeholder="Write category overview..."
    className="bg-white"
  />
</div>


          <div className="col-2 m-0">
            <button disabled={loading} className="btn btn-warning w-100 mt-3">
              {loading ? "Loading..." : editId ? "Update" : "Add"}
            </button>
          </div>

          {editId && (
            <div className="col-2 m-0">
              <button
                type="button"
                className="btn btn-secondary w-100 mt-3"
                onClick={resetForm}
              >
                Cancel
              </button>
            </div>
          )}
        </form>

        {/* Category table */}
        <div className="w-100 mt-5 Mon_font">
          <table className="table border">
            <thead>
              <tr>
                <th>#</th>
                <th>Thumbnail</th>
                <th>Banner Images</th>
                <th>Category Name</th>
                <th>Overview</th> {/* ✨ added */}
                <th className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {allCategory &&
                allCategory.map((cat, index) => (
                  <tr key={cat?._id}>
                    <td>{index + 1}</td>
                    <td>
                      <img
                        width={120}
                        className="border p-2 rounded"
                        src={cat?.url}
                        alt="Thumb"
                      />
                    </td>
                    <td className="d-flex flex-wrap gap-2">
                      {cat?.bannerImages?.map((b, i) => (
                        <img
                          key={i}
                          width={120}
                          className="border p-2 rounded"
                          src={b}
                          alt="Banner"
                        />
                      ))}
                    </td>
                    <td>{cat?.name}</td>
                   <td style={{ maxWidth: "250px" }}>
  <OverviewText text={cat?.overview || "-"} />
</td>

                    <td className="text-center d-flex gap-3 justify-content-center">
                      <EditIcon
                        className="text-primary"
                        style={{ cursor: "pointer" }}
                        onClick={() => editCategory(cat)}
                      />
                      <DeleteIcon
                        className="text-danger"
                        onClick={() => deleteCategory(cat?._id)}
                        style={{ cursor: "pointer" }}
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
};

export default AddCategory;
